export const createFormData = () => ({
  inputData: {
    type: 1,
    project_id: null,
    order_id:null,
    customer_id: null,
    form_name: null,
    ref_document_no: null,
    list_details: [],
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "installation_commissioning_list_masters",
    whereCondition: {
      is_active: true,
    },
  };

  const navigatePage = { back: "/installation-list" };

  const headerName = "Installation";

  const validationType = "InstallationCreate";
  const createEndpoint = "/saveRecords";
  const updateEndpoint = "/saveRecords";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};
